import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import NavigationUtil from 'utils/NavigationUtil';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';
import NavigationJsonBuilder from 'views/navigation/NavigationJsonBuilder';
import MenuItemView from 'views/navigation/MenuItemView';
import LeftNavigationAnalytics from 'utils/LeftNavigationAnalytics';
import templateHtml from 'templates/main/MainContainer/MainSidebarView.html';
import viewerUserPreferences from 'models/user/ViewerUserPreferences';
import {
    garminTrailsRoleKey, // Cleanup ticket: CA-159335
    runningToleranceRoleKey, // Cleanup ticket: CA-185063
    runningEconomyRoleKey // Cleanup ticket: CA-193107
} from 'models/preferences/PreferencesMapping';
import Preferences from 'models/preferences/Preferences';
import Loadable from 'utils/extensions/Loadable';

var Events = {
    EXPAND_COLLAPSE: 'EXPAND_COLLAPSE'
};

var LoadableView = Backbone.View.extend(Loadable);

var MainSidebarView = LoadableView.extend({
    template: _.template(templateHtml),

    events: {
        'click a.logo': 'goToModern',
        'click .beta-switch': 'toggleBeta'
    },

    initialize: function(args) {
        this.serviceHost = args.serviceHost;
        this.navCollapsedPref = args.navCollapsedPref;
        this.preferences = args.preferences;
        this.viewerAgentDevices = args.viewerAgentDevices;
        this.internalAppsHost = args.internalAppsHost;
        this.isAlphaUser = ViewerSocialProfile.isAlphaUser();
        this.isRaceEventProvider = ViewerSocialProfile.isRaceEventProvider();
        this.isBetaPool = jQuery('.beta-tag').length > 0;
        this.newsFeedStatus = args.newsFeedStatus;
        this.isGCPEnabled = args.isGCPEnabled;
        this.advancedReporting = args.advancedReporting;

        const locale = viewerUserPreferences.getFullLocale().replace('_', '-');
        this.activityTrackingAccuracyUrl = `http://www.garmin.com/${locale}/legal/atdisclaimer`;

        this.comCoursesRole = new Preferences({ key: garminTrailsRoleKey }); // Cleanup ticket: CA-159335
        this.toleranceRole = new Preferences({ key: runningToleranceRoleKey }); // Cleanup ticket: CA-185063
        this.economyRole = new Preferences({ key: runningEconomyRoleKey }); // Cleanup ticket: CA-193107
        this.mfp = args.mfp;
        this.usageIndicators = args.usageIndicators;
    },

    /**
     * Render the sidebar.
     */
    render: function() {
        var menuJson = NavigationJsonBuilder.getMenuJson(
            this.serviceHost,
            this.preferences,
            this.viewerAgentDevices,
            this.internalAppsHost,
            this.isComCoursesEnabled(),
            this.mfp,
            this.isGCPEnabled,
            this.advancedReporting,
            this.usageIndicators,
            this.showTolerance(),
            this.showEconomy()
        );
        var html = this.template({
            Localizer: Localizer,
            menuJson: menuJson,
            url: NavigationUtil.url,
            showMain: menuJson.main.length > 0,
            showSocial: menuJson.social.length > 0,
            showOther: menuJson.other.length > 0,
            beta: {
                isAlphaUser: this.isAlphaUser,
                isBetaPool: this.isBetaPool
            },
            activityTrackingAccuracyUrl: this.activityTrackingAccuracyUrl
        });

        this.$el.html(html);

        this.renderStaticDashboards(menuJson);
        this.renderMainEntries(menuJson);
        this.renderSocialEntries(menuJson);
        this.renderOtherEntries(menuJson);

        if (this.isBetaPool) {
            jQuery('.beta-tag').show();
        }

        // Recalculate the width of iframe pages and Highcharts
        // > Highcharts is already setup to listen for a window resize event
        // Golf Shot Map listens for resize event to correctly scale the map
        setTimeout(function() {
            $(window).trigger('resize.iframePage');
            window.dispatchEvent(new Event('resize'));
        }, 0);
    },

    isComCoursesEnabled: function() {
        return this.comCoursesRole.getFeatureEnabledForMultipleRoles();
    },

    showTolerance: function() {
        return this.toleranceRole.featureEnabled();
    },

    showEconomy: function() {
        return this.economyRole.featureEnabled();
    },

    /**
     * The parent will use a ModelSynchronizer to synchronize its dependencies prior to render. This function
     * allows the child to inject its own dependencies.
     * @param modelSynchronizer
     */
    provideDependencies: function(modelSynchronizer, tripCount) {
        if (tripCount === 0) {
            modelSynchronizer.addModel({ model: this.comCoursesRole, required: true }); // Cleanup ticket: CA-159335
            modelSynchronizer.addModel({ model: this.toleranceRole, required: true }); // Cleanup ticket: CA-185063
            modelSynchronizer.addModel({ model: this.economyRole, required: true }); // Cleanup ticket: CA-193107
        }
    },

    onDependenciesLoaded: function(tripCount) {
        if (tripCount < 3) {
            return false;
        }

        this.render();
    },

    renderOtherEntries: function(menuJson) {
        _.each(
            menuJson.other,
            function(item) {
                var menuItem = new MenuItemView({
                    model: item
                });
                this.listenTo(menuItem, MenuItemView.Events.NAV_ITEM_SELECTED, this.onNavClicked.bind(this, menuItem));
                this.$('.main-nav-group.other').append(menuItem.render().el);
            }.bind(this)
        );
    },

    renderSocialEntries: function(menuJson) {
        _.each(
            menuJson.social,
            function(item) {
                var menuItem = new MenuItemView({
                    model: item
                });
                this.listenTo(menuItem, MenuItemView.Events.NAV_ITEM_SELECTED, this.onNavClicked.bind(this, menuItem));
                this.$('.main-nav-group.social').append(menuItem.render().el);
            }.bind(this)
        );
    },

    renderMainEntries: function(menuJson) {
        _.each(
            menuJson.main,
            function(item) {
                var menuItem = new MenuItemView({
                    model: item
                });
                this.listenTo(menuItem, MenuItemView.Events.NAV_ITEM_SELECTED, this.onNavClicked.bind(this, menuItem));
                this.$('.main-nav-group.main').append(menuItem.render().el);
            }.bind(this)
        );
    },

    onNavClicked: function() {
        this.clearActiveNavItems();
        $('body').removeClass('mobile-open-main-nav');
    },

    clearActiveNavItems: function() {
        this.$('.main-nav-link').removeClass('active');
        this.$('.main-nav-menu-item').removeClass('active');
    },

    renderStaticDashboards: function(menuJson) {
        _.each(
            menuJson.dashboards,
            function(dashboard) {
                var menuItem = new MenuItemView({
                    model: dashboard,
                    newsFeedStatus: this.newsFeedStatus
                });
                this.listenTo(menuItem, MenuItemView.Events.NAV_ITEM_SELECTED, this.onNavClicked.bind(this, menuItem));
                this.$('.dashboards').append(menuItem.render().el);
            }.bind(this)
        );
    },

    goToModern: function(e) {
        if (!e.ctrlKey && !e.metaKey) {
            e.preventDefault();
        }
        LeftNavigationAnalytics.push('Connect');
        Backbone.history.navigate(`/home`, {
            trigger: true
        });
    },

    toggleBeta: function() {
        var reload = function() {
            location.reload();
        };
        var url = NavigationUtil.url('/service/beta');
        if (this.isBetaPool) {
            jQuery
                .ajax({
                    url: url,
                    type: 'DELETE'
                })
                .done(reload);
        } else {
            jQuery.post(url).done(reload);
        }
    }
});

MainSidebarView.Events = Events;

export default MainSidebarView;
